export default "__VITE_ASSET__D29DvHSi__"